export type Lesson = {
  id: string; // e.g. "1.1"
  title: string;
  runtime: string; // e.g. "3:53"
  playbackId: string | null;
  moduleNumber: number;
  /**
   * If true, the playbackId points to a Mux *public* policy asset and must be
   * played WITHOUT a signed JWT. Used for the free-preview lesson (1.1).
   * All other lessons default to signed playback.
   */
  isPublic?: boolean;
};

export type Module = {
  number: number;
  title: string;
  totalRuntime: string;
  lessons: Lesson[];
};

export const MODULES: Module[] = [
  {
    number: 1,
    title: "P&L",
    totalRuntime: "21:26",
    lessons: [
      { id: "1.1", title: "What is a P&L", runtime: "3:53", playbackId: "GXGRBFLNHyBswsqLtKCOPLfWPa7bimddirV6v8GMUVM", moduleNumber: 1, isPublic: true },
      { id: "1.2", title: "Why profit isn't the same as cash", runtime: "3:40", playbackId: "BoA696IH2Bud3omeSwhS7JIn400jveJzOzJABgMmQ01100", moduleNumber: 1 },
      { id: "1.3", title: "How your P&L connects to Companies House", runtime: "4:00", playbackId: "fyMUs78leIsf01HtBnK8j4hfpEdhFBltEBwdvc6WxGlc", moduleNumber: 1 },
      { id: "1.4", title: "Reading Big Companies", runtime: "4:14", playbackId: "yoNM9JSDQNT8PbAxto8QrFJoBUCfEr01T1u3cOSmPmds", moduleNumber: 1 },
      { id: "1.5", title: "Case Study: Carillion", runtime: "5:39", playbackId: "NDOZDFx1g2Eqq202lMqSmqZ9pPunwctNOXvPAguEgybU", moduleNumber: 1 },
    ],
  },
  {
    number: 2,
    title: "Revenue",
    totalRuntime: "23:46",
    lessons: [
      { id: "2.1", title: "What counts as revenue", runtime: "4:33", playbackId: "xyQGaqOhZ6GUQ019b239uHpiV3ahFbw5bOk63aUa9ZNI", moduleNumber: 2 },
      { id: "2.2", title: "When you're allowed to recognise it", runtime: "4:54", playbackId: "j5X01hfZX01ursIXZFUhVj01jUDlk02nZq00rjKPLtQVsc01g", moduleNumber: 2 },
      { id: "2.3", title: "Why growing revenue can hide a shrinking business", runtime: "2:37", playbackId: "iBccaQUyLOISbejPqdT57D1y1evDgILP7NFAK1knu00A", moduleNumber: 2 },
      { id: "2.4", title: "Reading the Revenue note", runtime: "5:59", playbackId: "OxfwYIa7OruWQJviGP00ufaYZH8ZsTC2GMDA9m8hcZ6Q", moduleNumber: 2 },
      { id: "2.5", title: "Case Study: Patisserie Valerie", runtime: "5:43", playbackId: "02zyfqedc00qLcxme00iBYBOJVPZgW5PGBApXj8BFjYZ1o", moduleNumber: 2 },
    ],
  },
  {
    number: 3,
    title: "Costs",
    totalRuntime: "26:05",
    lessons: [
      { id: "3.1", title: "Cost of sales vs Overheads", runtime: "5:15", playbackId: "pAWbbq3vRwtm25oEFRdNIpmkiB67NUjwL3VUcH9Xmv4", moduleNumber: 3 },
      { id: "3.2", title: "The three margins that matter", runtime: "4:31", playbackId: "7cC29yTJ701CUI302JCflg1GQK96vjTglp5mrTnVVWlO00", moduleNumber: 3 },
      { id: "3.3", title: "Spotting hidden costs in the notes", runtime: "5:02", playbackId: "3KWoyJvTabOGnLd8V8n02kzjc102uyBRZJciIFreDvmdw", moduleNumber: 3 },
      { id: "3.4", title: "Exceptional Items and when to be suspicious", runtime: "5:50", playbackId: "8vHSoCDHZfiW6VtdFbMTTlqs6lSFqhutHVEZB02mRBhg", moduleNumber: 3 },
      { id: "3.5", title: "Case Study: Marks & Spencer", runtime: "5:27", playbackId: "7mrh16dHGNy2u02VrhaYqcow13hapyIdWehmmRR42CoE", moduleNumber: 3 },
    ],
  },
  {
    number: 4,
    title: "Balance Sheet and Cash Flow",
    totalRuntime: "27:34",
    lessons: [
      { id: "4.1", title: "What the balance sheet always shows", runtime: "5:50", playbackId: "LE02BtdhSbjvb3O9GG5i02eJVjVYZEfMkiyFllSEPJpCA", moduleNumber: 4 },
      { id: "4.2", title: "Assets, Liabilities and what counts as equity", runtime: "5:50", playbackId: "x9zIFkVy01F01KB7I1jn33I00MULiY9GFkJMsCed027Wn5k", moduleNumber: 4 },
      { id: "4.3", title: "Working Capital", runtime: "4:30", playbackId: "kfB01GEkCiL01gPSK00XQ02P1gunqPiVcZieRunLP8v9aRo", moduleNumber: 4 },
      { id: "4.4", title: "The cash flow", runtime: "5:15", playbackId: "00z1NQo8njJIQqkoVKJMg9Yiiq6bRpte5Sr02C2THdy0000", moduleNumber: 4 },
      { id: "4.5", title: "Case Study: Thomas Cook", runtime: "6:09", playbackId: "OtjIKmq17XwlCAfRuM2V5Czk3ZlWHv39pOJjzUY8j5c", moduleNumber: 4 },
    ],
  },
  {
    number: 5,
    title: "How Tricks and Traps Hide in Accounts",
    totalRuntime: "28:20",
    lessons: [
      { id: "5.1", title: "Why accounts can lie", runtime: "4:53", playbackId: "Xy0200K02zq3Z3DinjbEppLbqfCtDPRpQxBML2lLPAJt3I", moduleNumber: 5 },
      { id: "5.2", title: "Revenue Tricks", runtime: "5:45", playbackId: "WzO6hmUpyNY00E01xZstsRXPbW1PySGHxh00udmaePx01GU", moduleNumber: 5 },
      { id: "5.3", title: "Cost and Profit tricks", runtime: "5:55", playbackId: "gT12cogMna02V2lqQijl02SR3DjpL2zB23AQ2iu8827Uo", moduleNumber: 5 },
      { id: "5.4", title: "Balance sheet tricks", runtime: "5:41", playbackId: "zBaHUYP00fbRU3vE02g01HvcwgSITzS009nmBNFTeUv02us8", moduleNumber: 5 },
      { id: "5.5", title: "Case Study: Quindell", runtime: "6:06", playbackId: "lwKcOHvILySEg187dpkHaO4tDBeiERWlRWTMEtXENhk", moduleNumber: 5 },
    ],
  },
  {
    number: 6,
    title: "Reading a Real Company: Greggs",
    totalRuntime: "14:17",
    lessons: [
      { id: "6.1", title: "Reading a real P&L", runtime: "4:02", playbackId: "a02USAbHOQgO3C00tZAkUh02behYqzORb4TEB8xluUMajU", moduleNumber: 6 },
      { id: "6.2", title: "Reading the balance sheet", runtime: "3:32", playbackId: "Ppt00caM1cR3kyB029JoG00FMiDnzLd01LvyBzNOHu00lSwg", moduleNumber: 6 },
      { id: "6.3", title: "Reading the cash flow", runtime: "3:53", playbackId: "KI7RI1wb02TfIo3rgExJxDLplLBpIKZW00F18K02rrXxGU", moduleNumber: 6 },
      { id: "6.4", title: "What you do with this", runtime: "2:50", playbackId: "dbffGSa3IbT2IM7OVxHB6VzCozVJRgjTTp5P2l024HE8", moduleNumber: 6 },
    ],
  },
];

export const ALL_LESSONS: Lesson[] = MODULES.flatMap((m) => m.lessons);

// Display labels for module references in UI (section titles, headlines).
// Module 6 is the bundle slot — its files are the full-course materials,
// so the label communicates that explicitly to avoid user confusion.
export const MODULE_LABELS: Record<number, string> = {
  1: "Module 1",
  2: "Module 2",
  3: "Module 3",
  4: "Module 4",
  5: "Module 5",
  6: "Module 6 (full course materials)",
};

export function getLesson(id: string): Lesson | undefined {
  return ALL_LESSONS.find((l) => l.id === id);
}

export function getModule(num: number): Module | undefined {
  return MODULES.find((m) => m.number === num);
}

export function getAdjacent(id: string): { prev: Lesson | null; next: Lesson | null } {
  const idx = ALL_LESSONS.findIndex((l) => l.id === id);
  if (idx === -1) return { prev: null, next: null };
  return {
    prev: idx > 0 ? ALL_LESSONS[idx - 1] : null,
    next: idx < ALL_LESSONS.length - 1 ? ALL_LESSONS[idx + 1] : null,
  };
}

export type QuizQuestion = {
  text: string;
  options: string[];
  correct: number;
  correctFeedback: string;
  incorrectFeedback: string;
};

export type LessonQuiz = {
  questions: QuizQuestion[]; // 1 (NPS final) or 2 (standard)
  activity?: QuizQuestion;   // optional real-world activity (X.4 of mods 3-5)
  isFinal?: boolean;         // NPS-style final, end of course
};

const LESSON_1_1_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "What is a P&L?",
      options: [
        "A list of every customer the business has",
        "A financial report showing money in, money out, and profit or loss over a period of time",
        "A legal document signed by directors",
        "A forecast of next year's sales",
      ],
      correct: 1,
      correctFeedback:
        "Correct. A P&L covers a period of time and shows revenue, costs, and profit or loss. Period of time matters. A balance sheet is a snapshot; a P&L is a film.",
      incorrectFeedback:
        "The answer is the second option. A P&L is a financial report showing money in, money out, and profit or loss over a period of time. A list of customers, a legal document, and a forecast are all real things — but they aren't a P&L.",
    },
    {
      text: "Which line sits at the top of every P&L?",
      options: ["Profit", "Tax", "Revenue", "Costs"],
      correct: 2,
      correctFeedback:
        "Correct. Revenue sits at the top of every P&L. From a corner café to a FTSE 100 — same shape.",
      incorrectFeedback:
        "The answer is Revenue. It sits at the top of every P&L — then costs, then profit. Same structure for every business, everywhere. The most important idea in Module 1.",
    },
  ],
};

const LESSON_1_2_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "Why is profit not the same as cash?",
      options: [
        "Because the bank applies different fees to each",
        "Because the P&L records revenue and costs when they are earned or incurred, not when cash moves",
        "Because cash is taxed and profit is not",
        "Because the two are calculated by different people",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Profit follows accruals — revenue is recognised when earned, costs when incurred, regardless of when cash moves. Cash follows the bank statement.",
      incorrectFeedback:
        "The answer is B. Profit follows accruals — money in and out when earned, not when paid. Cash follows the bank statement. They are two different views of the same business.",
    },
    {
      text: "A business buys a £30,000 van that will last 5 years. What does the P&L show in year one?",
      options: [
        "£30,000 — the full cost",
        "£6,000 — the cost spread over 5 years",
        "Nothing — vans are an asset, not a cost",
        "£30,000 in revenue",
      ],
      correct: 1,
      correctFeedback:
        "Correct. The cash goes out on day one, but the cost is spread across the asset's useful life as depreciation. The P&L sees one-fifth each year. Profit looks fine. The bank account has just taken a hit.",
      incorrectFeedback:
        "The answer is B — £6,000. Depreciation spreads the cost of the asset over its useful life. The P&L sees one-fifth each year, even though the full £30,000 left the bank in year one.",
    },
  ],
};

const LESSON_1_3_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "Where are UK limited companies required to file their accounts?",
      options: [
        "HMRC",
        "Companies House",
        "Their own website",
        "The Bank of England",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Companies House is the UK's official public register. Every UK limited company must file its annual accounts there.",
      incorrectFeedback:
        "The answer is B — Companies House. HMRC handles tax. Companies House handles the public record. Different jobs, different filings.",
    },
    {
      text: "Who can see a UK limited company's filed accounts on Companies House?",
      options: [
        "Only the company's own accountant",
        "Only directors and shareholders",
        "Anyone — they are public",
        "Only HMRC",
      ],
      correct: 2,
      correctFeedback:
        "Correct. Companies House filings are free, public, and searchable by anyone with an internet connection. No login required.",
      incorrectFeedback:
        "The answer is C. Anyone can see them. Free, public, searchable, no login. Most people don't know this. Now you do.",
    },
  ],
};

const LESSON_1_4_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "What is one document that listed companies publish each year?",
      options: [
        "An employment contract for every staff member",
        "An annual report containing the P&L, balance sheet, cash flow statement, and notes",
        "The CEO's bank statements",
        "A list of customer email addresses",
      ],
      correct: 1,
      correctFeedback:
        "Correct. A listed company's annual report contains the three financial statements, the notes that explain them, and the directors' commentary. It is the document this course teaches you to read.",
      incorrectFeedback:
        "The answer is B. The annual report is the public document that holds everything — P&L, balance sheet, cash flow, notes. It is the thing this course is teaching you to read.",
    },
    {
      text: "What is 'goodwill' on a company's accounts?",
      options: [
        "The reputation a company has with its customers",
        "The amount paid over the value of net assets when one company buys another",
        "Cash given to charity each year",
        "An estimate of how much the staff like working there",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Goodwill is the premium paid above the value of the actual net assets in an acquisition. It represents brand, customer relationships, and expected future earnings — none of which appear as physical assets on the balance sheet.",
      incorrectFeedback:
        "The answer is B. Goodwill is the amount paid above the net assets when one company buys another. It's the brand, the customers, the expected future profits — things that aren't physical but are still worth paying for.",
    },
  ],
};

const LESSON_2_1_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "Which of the following counts as revenue for a UK business?",
      options: [
        "A £50,000 bank loan deposited into the company account",
        "£100 paid by a customer for a product, of which £20 is VAT",
        "£80 — the same sale, excluding the VAT element",
        "A £15,000 cash injection from the business owner",
      ],
      correct: 2,
      correctFeedback:
        "Correct. Revenue is money earned from trading activities, excluding VAT. The £20 of VAT belongs to HMRC, not the business. Loans and owner injections are financing, not revenue.",
      incorrectFeedback:
        "The answer is C — £80. Revenue is what the business actually earned. The VAT was always HMRC's. Loans and owner injections are financing, not earnings.",
    },
    {
      text: "A landscaping company sells one of its vans for £6,000. How should this be treated?",
      options: [
        "Revenue, because cash came in",
        "Revenue, because it was sold to a customer",
        "Not revenue — it's a one-off disposal of an asset",
        "Revenue, but only if the van was bought new",
      ],
      correct: 2,
      correctFeedback:
        "Correct. Revenue is money from selling what the business sells. A landscaping company sells landscaping services, not vans. The van sale is a one-off disposal.",
      incorrectFeedback:
        "The answer is C. A landscaping company's revenue is landscaping. Selling a van is selling part of the business, not running it. It sits separately, not on the revenue line.",
    },
  ],
};

const LESSON_2_2_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "A consulting firm completes a £20,000 project in March, but the client doesn't pay until May. When is revenue recognised?",
      options: [
        "In May, when cash arrives",
        "In March, when the work is delivered",
        "Spread evenly across March, April, and May",
        "Whenever the company chooses",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Under IFRS 15, revenue is recognised when the performance obligation is satisfied — in this case, when the work is delivered. The cash timing is irrelevant.",
      incorrectFeedback:
        "The answer is B — March. Revenue is recognised when the work is done, not when the money lands. Accountants call this 'accruals'. You just need to remember it's the moment the obligation is fulfilled.",
    },
    {
      text: "A wedding photographer is paid a £2,000 deposit in January for a wedding in August. When can the photographer recognise the £2,000 as revenue?",
      options: [
        "In January, when the cash is received",
        "Spread evenly across January to August",
        "In August, when the wedding takes place and the service is delivered",
        "Whenever the photographer's accountant decides",
      ],
      correct: 2,
      correctFeedback:
        "Correct. The cash arrived in January, but the service hasn't been delivered yet. Until the wedding happens, the £2,000 is a liability — not revenue.",
      incorrectFeedback:
        "The answer is C — August. The cash is in the bank, but the work hasn't been done. Until the wedding happens, that £2,000 is a deposit, not revenue. The day of the wedding, it converts.",
    },
  ],
};

const LESSON_2_3_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "A retailer reports 15% revenue growth, but they acquired a competitor halfway through the year. What's the most important question to ask?",
      options: [
        "How big was the acquisition?",
        "What was the organic growth — excluding the acquired business?",
        "Who is the new CEO?",
        "What is their share price doing?",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Acquisitions inflate revenue mechanically — you've simply added another business. The real question is what the existing business did. That's organic growth, and it's what tells you whether the underlying company is healthy.",
      incorrectFeedback:
        "The answer is B. Acquisitions inflate top-line growth automatically. The real measure of business health is organic growth — what the existing business did on its own. Without that figure, the 15% is meaningless.",
    },
    {
      text: "A clothing retailer reports total revenue up 8%. Their like-for-like revenue is down 3%. What does this most likely mean?",
      options: [
        "The existing shops are doing worse, but new shops are inflating the total",
        "The business is genuinely thriving",
        "Their accounting is wrong",
        "Their stock has lost value",
      ],
      correct: 0,
      correctFeedback:
        "Correct. Like-for-like measures the existing stores only. If that's down 3% while total is up 8%, the growth is coming entirely from new stores — masking decline in the original business.",
      incorrectFeedback:
        "The answer is A. Total revenue up + like-for-like down = new shops papering over an existing-business problem. The retailer is opening new shops faster than the old ones are shrinking. It works until it doesn't.",
    },
  ],
};

const LESSON_2_4_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "In a company's revenue note, what does 'revenue by geography' tell you?",
      options: [
        "The CEO's home country",
        "Where the company's customers are located",
        "Where the company's offices are located",
        "The countries the company files tax returns in",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Revenue by geography breaks down where the customers are — and therefore where the business is genuinely making money. It often reveals dependencies on single markets that aren't obvious from the headline number.",
      incorrectFeedback:
        "The answer is B. Revenue by geography shows where the buying is actually happening. It's how you spot whether a 'global brand' is really just one market in disguise.",
    },
    {
      text: "Why is the revenue note often more useful than the top-line revenue figure on its own?",
      options: [
        "It includes the company's marketing budget",
        "It breaks revenue down by source, product, region, or channel — showing what's actually growing or shrinking",
        "It tells you the share price",
        "It includes a forecast for next year",
      ],
      correct: 1,
      correctFeedback:
        "Correct. The top-line revenue number tells you the total. The note tells you the composition — and that's where the real story is. Growth in one segment can hide decline in another.",
      incorrectFeedback:
        "The answer is B. The headline revenue figure is the total. The note is the breakdown — by region, product, channel. The breakdown is almost always where the real story is.",
    },
  ],
};

const LESSON_2_5_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "Patisserie Valerie collapsed in 2019 after auditors discovered the cash position was overstated. By approximately how much?",
      options: [
        "£2 million",
        "£40 million",
        "£94 million",
        "£500 million",
      ],
      correct: 2,
      correctFeedback:
        "Correct. £94 million of cash on the balance sheet didn't actually exist. The business looked healthy. The bank account told a very different story.",
      incorrectFeedback:
        "The answer is C — £94 million. The balance sheet showed nearly £100 million in cash. There was a fraction of that in the actual bank account. The auditors had missed it for years.",
    },
    {
      text: "What's the single biggest lesson Patisserie Valerie teaches anyone reading accounts?",
      options: [
        "Don't trust patisseries",
        "Always check whether the cash on the balance sheet matches the cash in the bank",
        "Only invest in private companies",
        "Avoid food businesses entirely",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Cash on the balance sheet should match the cash actually in the bank. When they don't, something is being manufactured. Patisserie Valerie is the textbook example.",
      incorrectFeedback:
        "The answer is B. Always check whether the cash position is real. The balance sheet number must match what's actually in the bank. Patisserie Valerie's didn't. By £94 million.",
    },
  ],
};

const LESSON_3_1_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "A plumber buys a £40 replacement part specifically for one customer's job. How should this cost be classified?",
      options: [
        "An overhead, because it's a small amount",
        "Cost of sales, because it only exists due to a specific job",
        "An overhead, because it's a one-off purchase",
        "Cost of sales only if the job is profitable",
      ],
      correct: 1,
      correctFeedback:
        "Correct. The £40 part only exists because of that specific sale. No job, no part. That's the test for cost of sales — does this cost only arise because of a specific sale? Yes. So it's cost of sales, regardless of size.",
      incorrectFeedback:
        "The answer is B. The £40 part only exists because of that specific sale. No job, no part. That's the test for cost of sales — does this cost only arise because of a specific sale? Yes. So it's cost of sales, regardless of size.",
    },
    {
      text: "A retailer reclassifies some of its distribution costs from cost of sales into overheads. What happens to the gross margin?",
      options: [
        "It stays the same — total costs haven't changed",
        "It goes down — overheads are higher",
        "It goes up — cost of sales looks lower",
        "It depends on how profitable the business is",
      ],
      correct: 2,
      correctFeedback:
        "Correct. Gross margin is gross profit divided by revenue. If you move costs out of cost of sales, gross profit goes up — so gross margin improves. The bottom line is unchanged, but the business looks more efficient at the top. This is why it's worth checking how a company defines its cost of sales.",
      incorrectFeedback:
        "The answer is C. Gross margin is gross profit divided by revenue. Move costs out of cost of sales and gross profit goes up — so gross margin improves. The bottom line is unchanged, but the business looks more efficient at the top.",
    },
  ],
};

const LESSON_3_2_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "A business has revenue of £500,000 and cost of sales of £200,000. What is its gross margin?",
      options: ["20%", "40%", "60%", "250%"],
      correct: 2,
      correctFeedback:
        "Correct. Gross profit = £500,000 − £200,000 = £300,000. Gross margin = £300,000 ÷ £500,000 = 60%. The gross margin tells you how much of every pound of revenue is left after the direct costs of producing what was sold.",
      incorrectFeedback:
        "The answer is C — 60%. Gross profit = £500,000 − £200,000 = £300,000. Gross margin = £300,000 ÷ £500,000 = 60%. That's how much of every pound of revenue is left after the direct costs.",
    },
    {
      text: "Which of the three margins tells you whether the entire business — including head office, finance costs, and tax — is profitable?",
      options: ["Gross margin", "Operating margin", "Net margin", "Marginal margin"],
      correct: 2,
      correctFeedback:
        "Correct. Net margin (profit for the year ÷ revenue) is the final figure after everything has been deducted — direct costs, overheads, interest, tax. It's the bottom-line measure of overall profitability.",
      incorrectFeedback:
        "The answer is C — Net margin. Profit for the year ÷ revenue, after everything has been deducted: direct costs, overheads, interest, tax. The bottom-line measure of overall profitability.",
    },
  ],
};

const LESSON_3_3_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "A company shows total cost of sales of £80m on the face of its P&L. The notes break this down further. Why is reading this breakdown useful?",
      options: [
        "The notes always disclose fraud",
        "The notes show what's actually inside cost of sales — for example, how much is depreciation, staff costs, or raw materials",
        "The notes are the only place tax is disclosed",
        "The notes show the CEO's salary",
      ],
      correct: 1,
      correctFeedback:
        "Correct. The face of the P&L gives you one big number. The notes break it down by category — depreciation, staff costs, raw materials, energy, and so on. This lets you understand the shape of the cost base, not just its total.",
      incorrectFeedback:
        "The answer is B. The face of the P&L gives you one big number. The notes break it down by category — depreciation, staff costs, raw materials, energy. That tells you the shape of the cost base, not just the total.",
    },
    {
      text: "In a typical UK annual report, where would you find a detailed breakdown of what sits inside \"cost of sales\"?",
      options: [
        "The directors' biographies",
        "The strategic report",
        "The notes to the financial statements",
        "The auditor's report",
      ],
      correct: 2,
      correctFeedback:
        "Correct. The face of the financial statements shows the headline numbers; the notes explain what's inside them. The notes are typically numbered and referenced from the face of the statements. This is where you find the actual breakdown of revenue, costs, assets, and liabilities.",
      incorrectFeedback:
        "The answer is C — the notes to the financial statements. The face shows the headline; the notes explain what's inside. That's where the actual breakdown of revenue, costs, assets, and liabilities lives.",
    },
  ],
};

const LESSON_3_4_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "What is an \"exceptional item\" in a set of accounts?",
      options: [
        "A one-off cost or gain that management considers unusual and worth flagging separately",
        "A cost that is exceptionally high in size",
        "A cost that the auditors find suspicious",
        "A profit item that exceeds expectations",
      ],
      correct: 0,
      correctFeedback:
        "Correct. Exceptional items are amounts that management has chosen to disclose separately because they consider them one-off or unusual — restructuring costs, impairments, gains on disposals, and so on. The label is applied by management, which is exactly why it's worth scrutinising.",
      incorrectFeedback:
        "The answer is A. Exceptional items are amounts management has chosen to disclose separately because they consider them one-off — restructuring costs, impairments, gains on disposals. The label is applied by management, which is exactly why it's worth scrutinising.",
    },
    {
      text: "A company reports \"exceptional restructuring costs\" every year for five years running. What should this make you suspect?",
      options: [
        "The company is being unusually transparent",
        "The costs aren't actually exceptional — they're recurring, and being labelled \"exceptional\" to flatter underlying profit",
        "The auditors are being too cautious",
        "The company is about to be acquired",
      ],
      correct: 1,
      correctFeedback:
        "Correct. If something happens every year, it's not exceptional — it's normal. Companies sometimes use the \"exceptional\" label to push recurring costs out of the headline profit figure, making the underlying business look more profitable than it really is. Recurring exceptional items are one of the clearest warning signs in a P&L.",
      incorrectFeedback:
        "The answer is B. If something happens every year, it's not exceptional — it's normal. The label gets used to push recurring costs out of the headline profit figure. Recurring exceptional items are one of the clearest warning signs in a P&L.",
    },
  ],
};


const LESSON_4_1_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "What is the key difference between a P&L and a balance sheet?",
      options: [
        "The P&L is for accountants, the balance sheet is for shareholders",
        "The P&L covers a period of time; the balance sheet is a snapshot at a single point in time",
        "The P&L shows assets, the balance sheet shows revenue",
        "The P&L is mandatory, the balance sheet is optional",
      ],
      correct: 1,
      correctFeedback:
        "Correct. The P&L tells you what happened over a year (or quarter). The balance sheet tells you what the business looks like on a specific day — typically the last day of the financial year. One is a video; the other is a photograph.",
      incorrectFeedback:
        "The answer is B. The P&L covers a period; the balance sheet is a snapshot on a single day — typically the last day of the financial year. One is a video; the other is a photograph.",
    },
    {
      text: "What is the accounting equation that every balance sheet follows?",
      options: [
        "Revenue − Costs = Profit",
        "Assets = Liabilities + Equity",
        "Cash In − Cash Out = Cash Flow",
        "Gross Profit − Overheads = Operating Profit",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Every balance sheet ever produced follows this equation. What the company owns (assets) must equal what it owes (liabilities) plus what's left over for the shareholders (equity). It's been the foundation of accounting for 500 years.",
      incorrectFeedback:
        "The answer is B — Assets = Liabilities + Equity. Every balance sheet follows this equation. What the company owns equals what it owes plus what's left for shareholders. The foundation of accounting for 500 years.",
    },
  ],
};

const LESSON_4_2_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "Which of the following is a current asset?",
      options: [
        "A factory building owned by the company",
        "Inventory waiting to be sold",
        "A long-term bank loan",
        "Goodwill from an acquisition",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Current assets are things expected to turn into cash within 12 months — inventory, receivables (money customers owe), and cash itself. A factory is a non-current asset (long-term). A loan is a liability. Goodwill is an intangible non-current asset.",
      incorrectFeedback:
        "The answer is B — inventory. Current assets are things expected to turn into cash within 12 months: inventory, receivables, cash itself. A factory is non-current. A loan is a liability. Goodwill is intangible non-current.",
    },
    {
      text: "Which of the following sits inside total equity on a balance sheet?",
      options: [
        "Trade payables",
        "A bank overdraft",
        "Retained earnings — profits the company has kept rather than paid out as dividends",
        "Inventory",
      ],
      correct: 2,
      correctFeedback:
        "Correct. Equity is what's left for the shareholders. It includes share capital (money raised from issuing shares) and retained earnings (profits kept inside the business over time). Payables and overdrafts are liabilities. Inventory is an asset.",
      incorrectFeedback:
        "The answer is C — retained earnings. Equity is what's left for shareholders: share capital plus retained earnings (profits kept inside the business). Payables and overdrafts are liabilities. Inventory is an asset.",
    },
  ],
};

const LESSON_4_3_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "How is working capital calculated?",
      options: [
        "Total assets minus total liabilities",
        "Current assets minus current liabilities",
        "Revenue minus cost of sales",
        "Operating profit minus tax",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Working capital is short-term assets minus short-term liabilities. It tells you whether the business has enough liquid resources to meet its obligations over the next 12 months. Total assets minus total liabilities gives you equity, not working capital.",
      incorrectFeedback:
        "The answer is B. Working capital is current assets minus current liabilities — short-term assets minus short-term obligations. Total assets minus total liabilities gives you equity, not working capital.",
    },
    {
      text: "A supermarket chain reports negative working capital. What is the most likely explanation?",
      options: [
        "The business is on the verge of bankruptcy",
        "Customers pay immediately at the till, but suppliers are paid on 30-60 day terms — the business uses supplier credit to fund operations",
        "The auditors have made a mistake",
        "The supermarket has too much inventory",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Negative working capital is normal — even healthy — for supermarkets and other fast-cash retailers. They collect cash from customers daily while paying suppliers weeks later. The float effectively funds part of their operations. The same pattern is dangerous in slower-cash businesses, which is why context always matters.",
      incorrectFeedback:
        "The answer is B. For supermarkets and fast-cash retailers, negative working capital is normal — even healthy. They collect cash from customers daily and pay suppliers weeks later. The float funds part of operations. Context always matters.",
    },
  ],
};

const LESSON_4_4_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "A cash flow statement is divided into three sections. Which of the following is one of them?",
      options: [
        "Strategic, operational, financial",
        "Operating, investing, financing",
        "Income, expenses, profit",
        "Assets, liabilities, equity",
      ],
      correct: 1,
      correctFeedback:
        "Correct. The cash flow statement always has three sections: cash from operating activities (the day-to-day business), cash from investing activities (buying or selling long-term assets), and cash from financing activities (raising or repaying debt, paying dividends). Together they explain every penny of cash movement.",
      incorrectFeedback:
        "The answer is B — Operating, investing, financing. The cash flow statement always has those three sections. Operating is the day-to-day. Investing is long-term assets bought or sold. Financing is debt and dividends. Together they explain every penny of cash movement.",
    },
    {
      text: "A company reports £142m of profit but £311m of operating cash flow. What is the most likely reason for the difference?",
      options: [
        "The company is overstating its cash position",
        "Depreciation — a non-cash cost that reduces profit but doesn't affect cash — is added back when calculating operating cash flow",
        "The auditors have miscounted",
        "The cash flow statement is wrong",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Profit is calculated after deducting depreciation (a non-cash cost). Operating cash flow adds depreciation back because no cash actually left the business — the cash was spent when the asset was originally bought. This is one of the main reasons profit and operating cash flow are different numbers for the same period.",
      incorrectFeedback:
        "The answer is B. Profit is calculated after deducting depreciation, a non-cash cost. Operating cash flow adds it back because no cash actually left the business — the cash was spent when the asset was originally bought. That's the main reason profit and operating cash flow differ.",
    },
  ],
};



const LESSON_5_1_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "What is the difference between fraud and aggressive accounting?",
      options: [
        "Fraud is intentional and illegal. Aggressive accounting bends the rules but stays inside them",
        "Fraud happens at small companies. Aggressive accounting happens at large companies",
        "Fraud is committed by employees. Aggressive accounting is committed by auditors",
        "There is no difference — both are illegal",
      ],
      correct: 0,
      correctFeedback:
        "Correct. Fraud is the deliberate falsification of accounts and is a criminal offence. Aggressive accounting is the use of permitted accounting choices to present the most flattering possible picture — technically legal, but designed to mislead. Most warning signs in real accounts sit in the grey zone between honest and fraudulent.",
      incorrectFeedback:
        "The answer is A. Fraud is the deliberate falsification of accounts — criminal. Aggressive accounting uses permitted choices to present the most flattering picture — technically legal, but designed to mislead. Most warning signs sit in the grey zone between the two.",
    },
    {
      text: "Which of the following best explains why directors might be motivated to dress up a set of accounts?",
      options: [
        "Auditors require them to",
        "Executive pay and share prices are often tied to reported profit, creating pressure to hit targets",
        "HMRC will reduce the company's tax bill",
        "It makes the accounts easier to read",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Directors are paid bonuses based on reported profit, and share prices respond to it. When a company is close to missing a forecast or a covenant, the incentive to bend the rules becomes significant. This pressure is one of the main reasons warning signs appear in real accounts.",
      incorrectFeedback:
        "The answer is B. Executive pay and share prices are often tied to reported profit. When a company is close to missing a forecast or a covenant, the incentive to bend the rules becomes significant. That pressure is why warning signs appear in real accounts.",
    },
  ],
};

const LESSON_5_2_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "What is \"channel stuffing\"?",
      options: [
        "A method of compressing financial data into a single line",
        "Forcing inventory onto distributors near year-end to inflate reported revenue",
        "Selling the same product twice to different customers",
        "Hiring extra staff in the run-up to year-end",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Channel stuffing means pressuring distributors or wholesalers to take more product than they need, just before the year-end cut-off, so the company can book revenue. The inventory often comes back through returns in the next period — but by then, the year-end number has already been reported.",
      incorrectFeedback:
        "The answer is B. Channel stuffing means pressuring distributors to take more product than they need just before year-end, so the company can book revenue. It often comes back as returns later — but the year-end number has already been reported.",
    },
    {
      text: "A software company invoices a customer £1 million in December for a service that will be delivered over the following 12 months. How much revenue can it recognise in December?",
      options: [
        "The full £1 million",
        "Roughly £83,000 — one month's worth of the 12-month service",
        "None of it — the cash hasn't arrived",
        "£500,000 — half, because half the cost has been incurred",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Under IFRS 15, revenue is recognised as the service is delivered. Invoicing the full amount upfront and recognising it all in December would be premature recognition — a classic revenue trick. The correct treatment is to spread the £1m across the 12 months the service is actually delivered.",
      incorrectFeedback:
        "The answer is B — around £83,000. Under IFRS 15, revenue is recognised as the service is delivered. Booking the full £1m in December would be premature recognition — a classic revenue trick. The £1m is spread across the 12 months it's actually delivered.",
    },
  ],
};

const LESSON_5_3_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "What does it mean to \"capitalise\" a cost?",
      options: [
        "To pay for it in capital (shares) rather than cash",
        "To record it as an asset on the balance sheet rather than as an expense on the P&L",
        "To use it as collateral for a loan",
        "To round the number up to the nearest £1,000",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Capitalising a cost means putting it on the balance sheet as an asset (to be depreciated over time) rather than expensing it immediately on the P&L. This keeps profit higher in the short term. Done legitimately, it reflects long-term assets. Done aggressively, it pushes costs that should hit the P&L into an asset that may never deliver value.",
      incorrectFeedback:
        "The answer is B. Capitalising means putting a cost on the balance sheet as an asset rather than expensing it immediately. Profit looks higher in the short term. Done legitimately, it reflects long-term assets. Done aggressively, it hides P&L costs in an asset that may never deliver value.",
    },
    {
      text: "A company books a large \"restructuring provision\" of £80m in a bad year, then quietly releases £15m of it back to profit each year for the next four years. What is happening?",
      options: [
        "The accounts are wrong",
        "Profit is being smoothed — bad year is made to look worse, later years are flattered by the provision release",
        "The restructuring is going better than expected",
        "The auditors made an error",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Booking a large provision in a bad year creates a reserve. Releasing it in good years inflates reported profit without any genuine improvement in the business. This is one of the oldest profit-smoothing tricks in the book, and it's exactly what to look for in the cost note disclosures.",
      incorrectFeedback:
        "The answer is B. Booking a large provision in a bad year creates a reserve. Releasing it in good years inflates reported profit without any genuine improvement in the business. One of the oldest profit-smoothing tricks in the book — exactly what to look for in cost note disclosures.",
    },
  ],
};

const LESSON_5_4_QUIZ: LessonQuiz = {
  questions: [
    {
      text: "A company acquired another business five years ago and booked £200m of goodwill. The acquired business has missed every profit forecast since. What should you check?",
      options: [
        "Whether the goodwill has been impaired",
        "Whether the auditors have been replaced",
        "Whether the company is paying dividends",
        "Whether the share price has fallen",
      ],
      correct: 0,
      correctFeedback:
        "Correct. Goodwill is required to be tested for impairment every year. If the acquired business is consistently underperforming, the goodwill should have been written down (impaired). Goodwill that never moves — even when the acquired business is clearly worth less than was paid — is one of the most common warning signs on a balance sheet.",
      incorrectFeedback:
        "The answer is A. Goodwill must be tested for impairment every year. If the acquired business is consistently underperforming, the goodwill should have been written down. Goodwill that never moves — even when the acquired business is clearly worth less than was paid — is one of the most common warning signs on a balance sheet.",
    },
    {
      text: "Before IFRS 16 came into force in 2019, where did most operating lease commitments appear?",
      options: [
        "As liabilities on the balance sheet",
        "As contingent liabilities only mentioned in the notes — they did not appear on the face of the balance sheet",
        "As revenue on the P&L",
        "On the cash flow statement only",
      ],
      correct: 1,
      correctFeedback:
        "Correct. Until IFRS 16, operating leases were off-balance-sheet — disclosed only as future commitments in the notes, not shown as liabilities. This let companies with vast lease portfolios (retailers, airlines, restaurants) appear much less indebted than they really were. IFRS 16 forced these obligations onto the balance sheet, and many companies' reported debt jumped overnight.",
      incorrectFeedback:
        "The answer is B. Until IFRS 16, operating leases were off-balance-sheet — disclosed only as future commitments in the notes. Retailers, airlines and restaurants looked much less indebted than they really were. IFRS 16 forced these onto the balance sheet, and many companies' reported debt jumped overnight.",
    },
  ],
};


const LESSON_6_4_FINAL: LessonQuiz = {
  isFinal: true,
  questions: [
    {
      text: "Would you recommend this course to a friend?",
      options: [
        "Yes. The link is already in three group chats",
        "Only to friends who can handle the truth",
        "Depends. Some of my friends still think gross margin is a band",
        "No. They had their chance to learn this on their own",
      ],
      correct: 0,
      correctFeedback: "",
      incorrectFeedback: "",
    },
  ],
};

const REAL_QUIZZES: Record<string, LessonQuiz> = {
  "1.1": LESSON_1_1_QUIZ,
  "1.2": LESSON_1_2_QUIZ,
  "1.3": LESSON_1_3_QUIZ,
  "1.4": LESSON_1_4_QUIZ,
  "2.1": LESSON_2_1_QUIZ,
  "2.2": LESSON_2_2_QUIZ,
  "2.3": LESSON_2_3_QUIZ,
  "2.4": LESSON_2_4_QUIZ,
  "2.5": LESSON_2_5_QUIZ,
  "3.1": LESSON_3_1_QUIZ,
  "3.2": LESSON_3_2_QUIZ,
  "3.3": LESSON_3_3_QUIZ,
  "3.4": LESSON_3_4_QUIZ,
  "4.1": LESSON_4_1_QUIZ,
  "4.2": LESSON_4_2_QUIZ,
  "4.3": LESSON_4_3_QUIZ,
  "4.4": LESSON_4_4_QUIZ,
  "5.1": LESSON_5_1_QUIZ,
  "5.2": LESSON_5_2_QUIZ,
  "5.3": LESSON_5_3_QUIZ,
  "5.4": LESSON_5_4_QUIZ,
  "6.4": LESSON_6_4_FINAL,
};

// Lessons explicitly with NO quiz: case studies for mods 3-5 (3.5, 4.5, 5.5)
// and module 6 teaching lessons 6.1, 6.2, 6.3.
export function getQuiz(id: string): LessonQuiz | null {
  return REAL_QUIZZES[id] ?? null;
}
